import { render } from "./VatRegistrationPanel.vue?vue&type=template&id=3646674f&scoped=true"
import script from "./VatRegistrationPanel.vue?vue&type=script&lang=js"
export * from "./VatRegistrationPanel.vue?vue&type=script&lang=js"

import "./VatRegistrationPanel.vue?vue&type=style&index=0&id=3646674f&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3646674f"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QCheckbox,QInput,QBtn});
